import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined in your config/api.js
import { useNavigate } from 'react-router-dom';

const StockAdjustmentsList = () => {
    // State for stock adjustments and filtered stock adjustments
    const [stockAdjustments, setStockAdjustments] = useState([]);
    const [filteredStockAdjustments, setFilteredStockAdjustments] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    // Fetch stock adjustments when the component mounts
    useEffect(() => {
        fetch(`${BASE_URL}stockadjustments`)
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 1) {
                    setStockAdjustments(data.data);
                    setFilteredStockAdjustments(data.data); // Set initial filtered stock adjustments
                }
            })
            .catch((error) => console.error('Error fetching stock adjustments:', error));
    }, []);

    // Handle search term change
    const handleSearchChange = (event) => {
        const term = event.target.value;
        setSearchTerm(term);

        // Filter stock adjustments based on the search term
        const filtered = stockAdjustments.filter((adjustment) =>
            adjustment.category.toLowerCase().includes(term.toLowerCase()) ||
            adjustment.sub_category.toLowerCase().includes(term.toLowerCase())
        );
        setFilteredStockAdjustments(filtered);
    };

    // Navigate to the edit stock adjustment page
    const handleEdit = (id) => {
        navigate(`/EditStockAdjustment/${id}`);
    };

    // Navigate to the add stock adjustment page
    const handleAdd = () => {
        navigate('/AddStockAdjustment');
    };

    // Handle stock adjustment deletion
    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this stock adjustment?")) {
            fetch(`${BASE_URL}stockadjustments/${id}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => response.json())
                .then((data) => {
                    if (data.status === 1) {
                        // Remove the deleted stock adjustment from both lists (stockAdjustments and filteredStockAdjustments)
                        setStockAdjustments(stockAdjustments.filter((adjustment) => adjustment.id !== id));
                        setFilteredStockAdjustments(filteredStockAdjustments.filter((adjustment) => adjustment.id !== id));
                    }
                })
                .catch((error) => console.error('Error deleting stock adjustment:', error));
        }
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Stock Adjustments List</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                <ol className="breadcrumb">
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            {/* Basic Tables start */}
            <section className="section">
                <div className="row" id="basic-table">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-md-6">
                                    </div>
                                    <div className="col-md-6 text-end">
                                        <button className="btn btn-primary" onClick={handleAdd}>Add Stock Adjustment</button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="mb-3">
                                    <label htmlFor="searchTerm" className="form-label">Search by Category or Sub-Category</label>
                                    <input
                                        type="text"
                                        id="searchTerm"
                                        className="form-control"
                                        placeholder="Search by category or sub-category"
                                        value={searchTerm}
                                        onChange={handleSearchChange}
                                    />
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-lg">
                                        <thead>
                                            <tr>
                                                <th>Category</th>
                                                <th>Sub-Category</th>
                                                <th>Pcs</th>
                                                <th>Signature</th>
                                                <th>Description</th>
                                                <th>Created At</th>
                                                <th className="text-end">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredStockAdjustments.map((adjustment) => (
                                                <tr key={adjustment.id}>
                                                    <td>{adjustment.category || 'N/A'}</td>
                                                    <td>{adjustment.sub_category || 'N/A'}</td>
                                                    <td>{adjustment.pcs || 'N/A'}</td>
                                                    <td>
                                                        <img
                                                            src={`http://localhost:8000/storage/signatures/${adjustment.signature}`} // Assuming the image is served from a public folder
                                                            alt="Signature"
                                                            style={{ width: 50, height: 50 }}
                                                        />
                                                    </td>
                                                    <td>{adjustment.description || 'N/A'}</td>
                                                    <td>{new Date(adjustment.created_at).toLocaleString()}</td>
                                                    <td className="text-end">
                                                        <button
                                                            className="btn btn-success"
                                                            onClick={() => handleEdit(adjustment.id)}
                                                        >
                                                            Edit
                                                        </button>
                                                        <button
                                                            className="btn btn-danger ms-2"
                                                            onClick={() => handleDelete(adjustment.id)}
                                                        >
                                                            Delete
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Basic Tables end */}
        </div>
    );
};

export default StockAdjustmentsList;
